import { AxiosInstance } from 'axios'
import {
  AddItemToCart,
  UpdateItemCartQuantity,
  GetCart,
  DeleteCartItem,
  GetCartResponse,
  AddItemToCartResponse,
  UpdateItemCartQuantityResponse,
  GetCheckoutSession,
  CreateCheckoutSession,
  ResumeCart,
  Cart,
  AbandonCart,
} from './types/photoProductsCart'

export class PhotoProductsCartApi {
  api: AxiosInstance
  private cartType?: string

  constructor(api: AxiosInstance) {
    this.api = api
  }

  setCartType(cartType: string | undefined) {
    this.cartType = cartType
  }

  private get cartTypeParams() {
    return this.cartType ? { cartType: this.cartType } : {}
  }

  addItemToCart: AddItemToCart = async (payload) => {
    const { data } = await this.api.post<AddItemToCartResponse>('/v1/photo-products-cart/items', {
      ...payload,
      ...this.cartTypeParams,
    })

    return data
  }

  updateItemCartQuantity: UpdateItemCartQuantity = async (itemId, payload) => {
    const { data } = await this.api.put<UpdateItemCartQuantityResponse>(
      `/v1/photo-products-cart/items/${itemId}`,
      payload,
      { params: this.cartTypeParams }
    )

    return data
  }

  getCart: GetCart = async () => {
    const { data } = await this.api.get<GetCartResponse>('/v1/photo-products-cart', {
      params: this.cartTypeParams,
    })
    return data
  }

  deleteCartItem: DeleteCartItem = async (itemId) => {
    const { data } = await this.api.delete<Cart>(`/v1/photo-products-cart/items/${itemId}`, {
      params: this.cartTypeParams,
    })
    return data
  }

  createCheckoutSession: CreateCheckoutSession = async () => {
    const { data } = await this.api.post<{
      clientSecret: string
      checkoutSessionId: string
    }>('/v1/photo-products-cart/checkout-session', null, {
      params: this.cartTypeParams,
    })
    return data
  }

  getCheckoutSession: GetCheckoutSession = async (id: string) => {
    const { data } = await this.api.get<{
      amount: number
      email: string
    }>(`/v1/photo-products-cart/checkout-session/${id}`, {
      params: this.cartTypeParams,
    })
    return data
  }

  resumeCart: ResumeCart = async () => {
    const { data } = await this.api.patch<Cart>('/v1/photo-products-cart/resume', null, {
      params: this.cartTypeParams,
    })

    return data
  }

  abandonCart: AbandonCart = async () => {
    const { data } = await this.api.patch<Cart>('/v1/photo-products-cart/abandon', null, {
      params: this.cartTypeParams,
    })

    return data
  }
}
